import type { ReactElement } from 'react';
import {
  type BoxNode,
  type FlatView,
  type HintSide,
  textHintPlacement,
} from '@/features/design-editor';
import { cn } from '@/shared/ui';

interface TextEditHintProps {
  readonly node: BoxNode;
  readonly view: FlatView;
}

/** 기준점에서 안내 상자를 어느 쪽으로 펼칠지 — 상자 바깥으로 향한다. */
const SIDE_CLASS: Record<HintSide, string> = {
  below: '-translate-x-1/2',
  above: '-translate-x-1/2 -translate-y-full',
  left: '-translate-x-full -translate-y-1/2',
  right: '-translate-y-1/2',
};

/**
 * 선택한 텍스트 옆의 작은 안내 — 더블클릭하면 글자를 고칠 수 있다고 알린다.
 * 회전 손잡이를 가리지 않게 손잡이 반대쪽(회전 반영 화면 외접 사각형 바깥)에 둔다.
 */
export const TextEditHint = ({ node, view }: TextEditHintProps): ReactElement => {
  const placement = textHintPlacement(node, view);
  return (
    <p
      data-testid="text-edit-hint"
      data-side={placement.side}
      className={cn(
        'pointer-events-none absolute rounded-full bg-foreground/85 px-2.5 py-1 text-[11px] font-medium whitespace-nowrap text-background shadow-sm',
        SIDE_CLASS[placement.side],
      )}
      style={{ left: placement.left, top: placement.top }}
    >
      더블클릭해서 글자 고치기
    </p>
  );
};
